import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import VueAxios from 'vue-axios'
import axios from 'axios'

// import 'primevue/resources/themes/bootstrap4-light-blue/theme.css' //theme
// import 'primevue/resources/primevue.min.css' //core css
import 'primeicons/primeicons.css' //icons
import 'primeflex/primeflex.css'
import './assets/gt_style.css'

const app = createApp(App);
app.config.globalProperties.$router = router;

app.config.globalProperties.$token = "";


app.config.globalProperties.session = {
    IsOnline: false,
}

window.$ = window.jQuery = require('jquery');
window.JQuery = require('jquery')

var $ = window.JQuery;
window.$ = $;

import PrimeVue from 'primevue/config';

import Button from 'primevue/button';
app.component('Button', Button);

import ButtonGroup from 'primevue/buttongroup';
app.component('ButtonGroup', ButtonGroup);

import InputText from 'primevue/inputtext';
app.component('InputText', InputText);

import AutoComplete from 'primevue/autocomplete';
app.component('AutoComplete', AutoComplete);

import IconField from 'primevue/iconfield';
app.component('IconField', IconField);

import InputIcon from 'primevue/inputicon';
app.component('InputIcon', InputIcon);

import InputMask from 'primevue/inputmask';
app.component('InputMask', InputMask);

import InputNumber from 'primevue/inputnumber';
app.component('InputNumber', InputNumber);

import Tag from 'primevue/tag';
app.component('Tag', Tag);

import Password from 'primevue/password';
app.component('Password', Password);

import Textarea from 'primevue/textarea';
app.component('Textarea', Textarea);

import Checkbox from 'primevue/checkbox';
app.component('Checkbox', Checkbox);

import Select from 'primevue/select';
app.component('Select', Select);

import SelectButton from 'primevue/selectbutton';
app.component('SelectButton', SelectButton);

import Card from 'primevue/card'
app.component('Card', Card);

import Dialog from 'primevue/dialog';
app.component('Dialog', Dialog);

import Menubar from 'primevue/menubar'
app.component('Menubar', Menubar);

import Menu from 'primevue/menu';
app.component('Menu', Menu);

import Chart from 'primevue/chart'
app.component('Chart', Chart);

import DataTable from 'primevue/datatable'
app.component('DataTable', DataTable);

import DataView from 'primevue/dataview';
app.component('DataView', DataView);

import OrderList from 'primevue/orderlist';
app.component('OrderList', OrderList);

import Column from 'primevue/column';
app.component('Column', Column);

import ColumnGroup from 'primevue/columngroup';
app.component('ColumnGroup', ColumnGroup);

import Toast from 'primevue/toast';
app.component('Toast', Toast);
import ToastService from 'primevue/toastservice';
app.use(ToastService);

import Timeline from 'primevue/timeline';
app.component('Timeline', Timeline);

import ProgressSpinner from 'primevue/progressspinner';
app.component('ProgressSpinner', ProgressSpinner);

import ConfirmPopup from 'primevue/confirmpopup';
app.component('ConfirmPopup', ConfirmPopup);

import ConfirmDialog from 'primevue/confirmdialog';
app.component('ConfirmDialog', ConfirmDialog);

import Calendar from 'primevue/calendar';
app.component('Calendar', Calendar);

import Listbox from 'primevue/listbox';
app.component('Listbox', Listbox);

import MultiSelect from 'primevue/multiselect';
app.component('MultiSelect', MultiSelect);

import Toolbar from 'primevue/toolbar';
app.component('Toolbar', Toolbar);

import RadioButton from 'primevue/radiobutton';
app.component('RadioButton', RadioButton);

import Avatar from 'primevue/avatar';
app.component('Avatar', Avatar);

import ScrollPanel from 'primevue/scrollpanel';
app.component('ScrollPanel', ScrollPanel);

import Panel from 'primevue/panel';
app.component('Panel', Panel);

import PickList from 'primevue/picklist';
app.component('PickList', PickList);

import Tree from 'primevue/tree';
app.component('Tree', Tree);

import FileUpload from 'primevue/fileupload';
app.component('FileUpload', FileUpload);

import Divider from 'primevue/divider';
app.component('Divider', Divider);

import InputGroup from 'primevue/inputgroup';
app.component('InputGroup', InputGroup);

import InputGroupAddon from 'primevue/inputgroupaddon';
app.component('InputGroupAddon', InputGroupAddon);

import FloatLabel from 'primevue/floatlabel';
app.component('FloatLabel', FloatLabel);

import Tabs from 'primevue/tabs';
app.component('Tabs', Tabs);

import TabList from 'primevue/tablist';
app.component('TabList', TabList);

import Tab from 'primevue/tab';
app.component('Tab', Tab);

import TabPanels from 'primevue/tabpanels';
app.component('TabPanels', TabPanels);

import TabPanel from 'primevue/tabpanel';
app.component('TabPanel', TabPanel);

import Skeleton from 'primevue/skeleton';
app.component('Skeleton', Skeleton);

import ProgressBar from 'primevue/progressbar';
app.component('ProgressBar', ProgressBar);

import DatePicker from 'primevue/datepicker';
app.component('DatePicker', DatePicker);

import Message from 'primevue/message';
app.component('Message', Message);

import TieredMenu from 'primevue/tieredmenu';
app.component('TieredMenu', TieredMenu);

import BlockUI from 'primevue/blockui';
app.component('BlockUI', BlockUI);

import Badge from 'primevue/badge';
app.component('Badge', Badge);

import OverlayBadge from 'primevue/overlaybadge';
app.component('OverlayBadge', OverlayBadge);

import Galleria from 'primevue/galleria';
app.component('Galleria', Galleria);

import Image from 'primevue/image';
app.component('Image', Image);

import Editor from 'primevue/editor';
app.component('Editor', Editor);

import InputSwitch from 'primevue/inputswitch';
app.component('InputSwitch', InputSwitch);


// // import as directive
// import BadgeDirective from 'primevue/badgedirective';
// app.directive('Badge', BadgeDirective);




//----------------------- Custom ------------------------------------
import IslemYapiliyor from './components/HelperLayout/IslemYapiliyor.vue';
app.component('IslemYapiliyor', IslemYapiliyor);

import Wait_Skeleton from './components/HelperLayout/Wait_Skeleton.vue';
app.component('Wait_Skeleton', Wait_Skeleton);

//- ------------------------------------------------


// -------------------------------------------------
import VueScrollTo from 'vue-scrollto';
app.use(VueScrollTo);


import Aura from '@primevue/themes/aura';
// import Nora from '@primevue/themes/nora';
// import Lara from '@primevue/themes/lara';

app.use(PrimeVue,
    {
        theme:
        {
            preset: Aura,
            // options: {
            //     prefix: 'p',
            //     darkModeSelector: 'system',
            //     cssLayer: false
            // }
        },
        // zIndex: {
        //     modal: 1100,        //dialog, drawer
        //     overlay: 1000,      //select, popover
        //     menu: 3000,         //overlay menus
        //     tooltip: 1100,       //tooltip,
        // },
    },


);

app.use(router);
app.use(store);
app.use(VueAxios, axios);

import ConfirmationService from 'primevue/confirmationservice';
app.use(ConfirmationService);

app.mount('#app');